module.exports = __webpack_public_path__ + "static/media/news-dr-john-bennett-and-dan-pickett-meeting.e5bbbf74.jpg";